<app-base-layout>
    <div class="waiting-body">
        <ng-container [ngSwitch]="loader">
            <span class="card-loader" *ngSwitchCase="'card'"></span>
            <span class="smilego-loader" *ngSwitchCase="'smilego'"></span>
            <mat-spinner [diameter]="100" class="color-spinner" *ngSwitchCase="'default'"></mat-spinner>
        </ng-container>
        <h1>{{waitingTitle ? waitingTitle : ""}}</h1>
        <h2>{{ waitingObservation }}</h2>
    </div>
</app-base-layout>
  